import { createSlice } from '@reduxjs/toolkit';

const resumeSlice = createSlice({
  name: 'resume',
  initialState: {
    downloadStarted: false,
  },
  reducers: {
    setResumeDownloadProgress: (state, action) => {
      const { downloadStarted } = action.payload;
      state.downloadStarted = downloadStarted;
    },
  },
});

export const { setResumeDownloadProgress } = resumeSlice.actions;

export const selectResumeDownloadStarted = (state) => state.resume.downloadStarted;

export default resumeSlice.reducer;
